import React from 'react'
import {Icon} from '@chakra-ui/react'

const SwatchCheckIcon = (props) => {
    return (
        <Icon
            viewBox="0 0 8 6"
            width="8"
            height="6"
            fill="none"
            data-testid="swatch-check-icon"
            {...props}
        >
            <path
                d="M6.84175 0.175667C7.07608 -0.0585099 7.45612 -0.0586016 7.69038 0.175667C7.92416 0.409916 7.92425 0.789131 7.69038 1.02332L3.10738 5.60731C2.99495 5.71973 2.84155 5.78298 2.68257 5.78309C2.52377 5.783 2.37115 5.71948 2.25874 5.60731L0.175736 3.52332C-0.0585786 3.28901 -0.0585786 2.90998 0.175736 2.67567C0.410061 2.44149 0.789123 2.4414 1.02339 2.67567L2.68257 4.33387L6.84175 0.175667Z"
                fill="#EFEDEA"
            />
        </Icon>
    )
}

export default SwatchCheckIcon
